import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class RoutelinksService {

  // Lista de links para el sidebar
  linksIVATypes = [
    { baseURL: "ivatypes", name: "ivaTypes", url: "ivatypes" },
    { baseURL: "ivatypes", name: "ivaPattern", url: "ivapattern" }
  ];

  linksTaxes = [
    { baseURL: "taxes", name: "services", url: "services" },
    { baseURL: "taxes", name: "catalog", url: "servicesAdministrative" },
    { baseURL: "taxes", name: "taxesModels", url: "models" },
  ];

  subLinksTaxes = [
    { baseURL: "taxes", name: "academicTaxes", url: "academic" },
    { baseURL: "taxes", name: "learningTaxes", url: "learning" },
    { baseURL: "taxes", name: "administrativeTaxes", url: "administrative" },
    { baseURL: "taxes", name: "sendTaxes", url: "send" },
    { baseURL: "taxes", name: "recharges", url: "surcharge" },
  ];

  linksAdministration = [
    { baseURL: "administration", name: "languages", url: "languages" },
    { baseURL: "administration", name: "role", url: "roles" },
    { baseURL: "administration", name: "users", url: "users" },
  ];

  linksDiscount = [
    { baseURL: "discounts", name: "catalogDiscount", url: "catalog" },
    { baseURL: "discounts", name: "controlTypes", url: "controlTypes" },
    { baseURL: "discounts", name: "discountControl", url: "discountControl" }
  ];

  linksEnrollment = [
    { baseURL: "enrollment", name: "modify", url: "modification" },
    { baseURL: "enrollment", name: "cancellation", url: "cancellation" },
  ];

  linksCoins = [
    { baseURL: "coins", name: "coins", url: "coins" },
  ];

  linksLauncher = [
    { baseURL: "launcher", name: "paramLauncher", url: "launcher" },
    { baseURL: "tuition-calculation", name: "paramTuitionCall", url: "tuition-calculation" }
  ];

  constructor() { }
}
